import axios from 'axios'
import qs from 'qs'

export const getTutorials = params => axios.get(`/api/tutorials?${qs.stringify(params, { skipNulls: true })}`)

export const updateTutorial = ({ name, body }) => axios.put(`/api/tutorials/${name}`, body)

export const getTutorialsInfoV2 = () => axios.get('/api/tutorials')
